import { useMutation } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export const useMakeAllInactive = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useMutation(async () => {
    const token = await getAccessTokenSilently();
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/events/make-all-inactive`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  });
};
